module.exports = __webpack_public_path__ + "img/award (5).efb70a6d.jpg";